import React from "react";

function DvirCohen() {
  return (
    <svg
      width="176"
      height="175"
      viewBox="0 0 176 175"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="88" cy="87.5" r="87" stroke="black" />
      <mask
        id="mask0_6_283"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="176"
        height="175"
      >
        <circle cx="88" cy="87.5" r="87.5" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6_283)">
        <path
          d="M72.8187 94.4561C81.6422 102.833 91.7322 112.577 90.8731 124.714C90.6221 128.252 89.2928 131.845 86.6075 134.163C82.812 137.439 76.8848 137.789 73.7406 141.692C70.904 145.213 71.4987 150.67 74.2416 154.264C76.9856 157.856 81.4015 159.82 85.8286 160.735C95.9485 162.826 106.985 159.866 114.702 152.993C115.921 151.908 117.088 150.69 117.695 149.176C118.761 146.515 117.918 143.51 117.013 140.791C113.975 131.651 110.265 122.071 112.341 112.667C114.673 102.109 123.739 94.4037 128.075 84.4989C132.107 75.2855 131.679 64.2376 126.947 55.3637C125.17 52.0312 122.696 48.8994 119.277 47.2995C116.05 45.7891 112.345 45.7943 108.784 45.9034C95.1789 46.3211 70.7713 44.8467 61.1669 56.7516C50.8948 69.4827 63.4726 85.5812 72.8187 94.4561Z"
          fill="#FFE7FB"
        />
        <path
          d="M59.5603 163.678C58.1991 161.672 56.6908 159.676 54.6136 158.424C49.9539 155.617 43.6264 157.442 39.6797 161.187C35.732 164.932 33.6125 170.158 31.6052 175.216C30.5414 177.893 29.4786 180.572 28.4158 183.25C27.0659 186.65 25.7027 190.107 25.3621 193.749C25.0226 197.391 25.8406 201.309 28.3643 203.957C30.527 206.228 33.6527 207.305 36.7176 207.971C43.8517 209.518 51.2389 209.257 58.5356 208.988C84.4988 208.03 68.3231 176.591 59.5603 163.678Z"
          fill="#6987FF"
        />
        <path
          d="M113.173 181.792C113.95 177.471 114.193 173.065 115.04 168.756C115.954 164.103 117.573 159.587 119.823 155.413C121.058 153.123 122.661 150.788 125.118 149.935C127.517 149.103 130.212 149.901 132.361 151.252C138.858 155.335 141.269 163.476 143.18 170.906C145.492 179.895 147.804 188.882 150.116 197.869C150.583 199.683 150.837 202.055 149.224 203.006C148.594 203.375 147.829 203.406 147.098 203.426C136.359 203.708 123.541 205.211 112.975 203.071C106.253 201.709 107.372 202.405 109.091 195.828C110.329 191.092 112.299 186.658 113.173 181.792Z"
          fill="#6987FF"
        />
        <path
          d="M80.578 191.098C81.7334 194.042 83.037 197.173 85.6832 198.903C89.3428 201.298 94.5293 200.057 97.6961 197.041C100.863 194.023 102.371 189.665 103.253 185.381C104.135 181.097 104.506 176.686 105.923 172.548C107.318 168.468 109.723 164.657 110.113 160.362C110.219 159.205 109.988 157.76 108.892 157.373C108.412 157.205 107.883 157.296 107.385 157.403C103.253 158.297 99.3474 160.211 95.1415 160.643C87.8736 161.389 76.013 152.687 72.3091 161.068C68.8881 168.808 77.8124 184.056 80.578 191.098Z"
          fill="#DAC8FF"
        />
        <path
          d="M76.0886 90.6713C73.5874 90.6949 71.0873 90.7196 68.5851 90.7443C67.867 90.7515 67.0511 90.8019 66.5912 91.3534C66.0233 92.0324 66.3597 93.1385 67.0532 93.6879C67.7476 94.2363 68.6695 94.3762 69.5461 94.4965C70.6737 94.6519 71.8003 94.8062 72.9279 94.9626C74.5175 95.1807 76.3201 95.3423 77.5444 94.3072C78.7688 93.2712 78.3089 90.6486 76.71 90.771"
          fill="#F03FA3"
        />
        <path
          d="M111.256 91.927C108.755 91.9507 106.254 91.9753 103.754 92C103.035 92.0072 102.219 92.0577 101.758 92.6102C101.191 93.2892 101.526 94.3942 102.221 94.9426C102.914 95.491 103.837 95.6309 104.714 95.7512C105.84 95.9076 106.968 96.062 108.095 96.2184C109.684 96.4365 111.487 96.598 112.712 95.563C113.936 94.5269 113.476 91.9043 111.878 92.0257"
          fill="#F03FA3"
        />
        <path
          d="M29.4129 200.588L34.5881 176.79C37.3146 164.248 44.9795 153.342 55.8546 146.52L75.9687 133.906L76.514 128.135L77.9338 113.227L77.975 112.805"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M142.618 97.9249C140.044 88.9142 131.158 43.4994 131.158 43.4994L111.602 42.486C120.291 50.1067 122.7 60.3232 122.7 60.3232C122.298 72.5656 120.405 82.2986 117.73 90.0459H117.72C114.633 99.0073 110.467 105.305 106.3 109.708C104.931 111.159 103.553 112.404 102.215 113.463C99.6326 115.532 97.184 116.94 95.1571 117.876C91.8545 119.43 89.6219 119.77 89.6219 119.77C83.243 117.384 78.109 113.854 73.973 109.708C55.8342 91.476 56.8528 61.0949 56.4001 60.3232C56.4001 60.3232 55.9896 47.8432 67.0107 40.1741L49.1014 39.2461C49.1014 39.2461 44.238 66.91 41.1781 87.1692C38.1183 107.428 41.6545 120.772 55.1881 122.188C68.7217 123.604 120.052 122.188 120.052 122.188C120.052 122.188 149.55 122.188 142.618 97.9249Z"
          fill="black"
        />
        <path
          d="M102.194 113.288L102.215 113.463L102.781 119.452L104.149 133.907L110.898 138.146H110.919V138.156L124.263 146.52C135.138 153.343 142.803 164.249 145.53 176.79L148.75 191.615L150.705 200.588"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M69.1055 69.0235C69.1055 69.0235 75.0029 67.0142 80.9013 69.0235"
          stroke="black"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M76.8911 77.8703C76.8911 79.5319 76.0454 80.8776 75.0032 80.8776C73.962 80.8776 73.1162 79.5319 73.1162 77.8703C73.1162 76.2087 73.962 74.8629 75.0032 74.8629C76.0454 74.8629 76.8911 76.2087 76.8911 77.8703Z"
          fill="black"
        />
        <path
          d="M110.74 69.0233C110.74 69.0233 104.842 67.0139 98.9445 69.0233"
          stroke="black"
          stroke-width="2"
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="bevel"
        />
        <path
          d="M102.954 77.8705C102.954 79.5321 103.799 80.8779 104.841 80.8779C105.883 80.8779 106.729 79.5321 106.729 77.8705C106.729 76.2089 105.883 74.8632 104.841 74.8632C103.799 74.8632 102.954 76.2089 102.954 77.8705Z"
          fill="black"
        />
        <path
          d="M88.6109 77.901C88.7292 78.1592 89.2457 82.5298 85.9431 85.3756C85.9431 85.3756 85.2599 88.2492 90.2139 88.3151"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M82.8289 97.2898C82.8289 97.2898 91.1493 100.048 97.5982 97.4318"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M57.4299 71.8164C57.4299 71.8164 50.5243 63.1287 46.9675 67.1567C43.4118 71.1847 50.4029 90.6959 61.3766 88.4108"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M51.4873 74.9664C51.4873 74.9664 56.6779 74.9952 58.891 79.1127"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M54.2412 79.1049C54.2412 79.1049 54.4069 77.3312 57.7311 77.5431"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M121.937 71.8165C121.937 71.8165 128.843 63.1288 132.398 67.1568C135.955 71.1848 128.963 90.696 117.99 88.4109"
          fill="#F7F6F2"
        />
        <path
          d="M128.073 74.9667C128.073 74.9667 122.882 74.9955 120.669 79.113"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M125.318 79.1049C125.318 79.1049 125.152 77.3312 121.828 77.5431"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M56.4004 60.3234C56.8531 61.095 55.8346 91.4761 73.9733 109.708C78.1093 113.854 83.2433 117.384 89.6222 119.77C89.6222 119.77 91.8548 119.431 95.1575 117.877C97.1843 116.94 99.633 115.532 102.215 113.463C103.553 112.404 104.932 111.159 106.3 109.708C110.467 105.305 114.634 99.0074 117.72 90.046H117.731C120.406 82.2987 122.299 72.5657 122.7 60.3234"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M114.529 50.6227C114.529 50.6227 93.1109 71.6721 57.4312 73.8749C57.4312 73.8749 46.4275 62.2231 49.1015 41.3043C51.7755 20.3856 96.9197 -3.53429 122.707 29.3367C122.707 29.3367 143.547 45.0782 121.936 73.8749C121.936 73.8749 123.179 68.5526 114.529 50.6227Z"
          fill="black"
        />
        <path
          d="M65.1602 140.684C65.1602 140.684 77.9304 154.53 91.253 158.516C91.253 158.516 105.486 156.509 114.174 140.192"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M62.7874 142.173C62.7874 142.173 72.3784 157.047 90.9379 161.765C90.9379 161.765 111.4 156.928 116.503 141.653"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M61.3946 143.045C61.3946 143.045 71.75 175.239 76.3109 200.587"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M50.8284 150.154C50.8284 150.154 46.5854 164.754 55.236 174.033C63.8856 183.313 74.3604 190.841 74.3604 190.841"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M118.734 143.045C118.734 143.045 108.377 175.239 103.817 200.587"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M129.303 150.154C129.303 150.154 133.545 164.753 124.894 174.033C116.244 183.313 105.77 190.841 105.77 190.841"
          stroke="black"
          stroke-miterlimit="10"
        />
        <path
          d="M102.781 119.452C95.7337 121.859 83.48 125.862 76.5147 128.136L77.9345 113.228C81.268 115.851 85.1365 118.093 89.6223 119.77C89.6223 119.77 91.8549 119.432 95.1576 117.877C97.1844 116.941 99.6331 115.532 102.216 113.463L102.781 119.452Z"
          fill="black"
        />
      </g>
    </svg>
  );
}

export default DvirCohen;
